
import { buscarApi } from "../../apis";
import { useBuscadorTodoStore } from "../../stores/ui/buscadorTodo.store";

import Swal from "sweetalert2";




export const rastrearOrdenProduccion = async(termino) => {
    try {
        const { data } = await buscarApi.get(`/rastrear/home/${termino}`);
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}



export const buscadorGlobalAdmin = async(termino) => {
    try {
        const params = new URLSearchParams();
        params.append('termino',  termino);

        const { data } = await buscarApi.get(`/buscador/global`, { params });
        return data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}




export const buscadorCajaVentas = async({ page=0, termino='', inicio, final, medio }) => {
    try {
        const params = new URLSearchParams();
        params.append('page',  page.toString());
        params.append('termino',  termino);
        params.append('inicio',  inicio);
        params.append('final',  final);
        params.append('medio',  medio);

        const { data } = await buscarApi.get(`/buscador/caja/ventas`, { params });
        useBuscadorTodoStore.setState({ totalVentaCaja: data.total });
        return data.data;
        
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}





export const recalcularVentaCaja = async({ termino='', inicio, final, medio }) => {
    try {
        const params = new URLSearchParams();
        params.append('termino',  termino);
        params.append('inicio',  inicio);
        params.append('final',  final);
        params.append('medio',  medio);

        const { data } = await buscarApi.get(`/recalcular/caja/ventas`, { params });
        return data.data;
    } catch (error) {
        const errores = error.response.data['msg'] || error.response.data.errors[0]['msg'];
        Swal.fire('Error', errores, 'error');
        return false;
    }
}


